var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"bold red f-large",attrs:{"id":_vm.id}},[_vm._v(_vm._s(_vm._f("insertComma")(_vm.count)))])}
var staticRenderFns = []

export { render, staticRenderFns }